import React, { useRef } from 'react';
import { useDrop, useDrag, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import CustomSection from '../CustomSection';

function CustomSectionRecivingEnd({
  element,
  eleIndex,
  dropInLocation,
  fromForm,
  modfiyReqAndEnable,
  deleteCard,
  duplicatingItem,
  editingInput,
  deleteItem,
  changeLabel,
  dropLocation,
  onChange,
}) {
  const { t } = useTranslation('common');

  const cardRef = useRef(null);

  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  const [{ cardOver, item }, drop] = useDrop({
    accept: 'container',
    drop: () => {
      dropLocation(eleIndex, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      cardOver: monitor.isOver(),
    }),
  });

  drop(cardRef);

  return (
    <DndProvider backend={HTML5Backend}>
      <div ref={cardRef}>
        {cardOver && (
          <div className="potemplate-drag-placeholder"> {t('PO_TEMPLATES.PO_DETAILS.RECIVING_END.CUSTOM_SECTION_RECIVING_END.DROP_SECTION_HERE')}</div>
        )}
        <CustomSection
          element={element}
          eleIndex={eleIndex}
          dropInSectionLocation={dropInLocation}
          fromForm={fromForm}
          modfiyReqAndEnable={modfiyReqAndEnable}
          deleteCard={deleteCard}
          duplicatingItem={duplicatingItem}
          editingInput={editingInput}
          elekey={element?.key}
          showDelete={fromForm}
          deleteItem={deleteItem}
          changeLabel={changeLabel}
          dropLocation={dropLocation}
          dropInLocation={dropInLocation}
          itemDragging={itemDragging}
          onChange={onChange}
          fromCustomSection
        />
      </div>
    </DndProvider>
  );
}

export default CustomSectionRecivingEnd;
